import React from "react";
import StatCard from "./StatCard";

const NUMBER_TILES = [
  { key: "questions", label: "Questions" },
  { key: "subjects", label: "Subjects" },
  { key: "notes", label: "Notes" },
  { key: "quizQuestions", label: "Quiz Questions" },
  { key: "practiceQuestions", label: "Practice Questions" },
  { key: "assignmentQuestions", label: "Assignment Questions" },
  { key: "testsCreated", label: "Tests Created" },
  { key: "students", label: "Students" },
  { key: "courses", label: "Courses" },
  { key: "batchesActive", label: "Batches Active" },
  { key: "batchesCompleted", label: "Batches Completed" },
  { key: "trainers", label: "Trainers" },
];

const NumbersGrid = ({ numbers, loading, error }) => {
  return (
    <section className="dash-section">
      <h2 className="dash-section-title">Numbers</h2>
      {error ? (
        <div className="dash-section-error">Couldn't load numbers: {error}</div>
      ) : (
        <div className="dash-numbers-grid">
          {NUMBER_TILES.map((tile) => (
            <StatCard
              key={tile.key}
              label={tile.label}
              value={numbers?.[tile.key]}
              loading={loading}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default NumbersGrid;
